/* assets/glixor-product.js */
(function () {
  'use strict';

  var DESKTOP = '(min-width: 750px)';
  function isDesktop() { return window.matchMedia(DESKTOP).matches; }

  /* ================================================================
     Gallery
     ================================================================ */
  class GlixorGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-stage-track]');
      this.slides = Array.prototype.slice.call(this.querySelectorAll('.gx_slide'));
      this.thumbs = Array.prototype.slice.call(this.querySelectorAll('.gx_thumb'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('.gx_dot'));
      this.thumbRail = this.querySelector('.gx_thumbs');
      this.thumbTrack = this.querySelector('[data-thumb-track]');
      this.counter = this.querySelector('[data-stage-count]');
      if (!this.slides.length) return;

      this.index = Math.max(0, this.slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
      this.variantMap = this.readVariantMap();
      this.scope = this.closest('main-product') || document;

      this.onClick = this.onClick.bind(this);
      this.onStageScroll = this.throttle(this.onStageScroll.bind(this), 80);
      this.onThumbScroll = this.throttle(this.updateThumbNav.bind(this), 80);
      this.onVariantEvent = this.onVariantEvent.bind(this);
      this.onFormChange = this.onFormChange.bind(this);
      this.onKey = this.onKey.bind(this);
      this.measure = this.measure.bind(this);

      this.addEventListener('click', this.onClick);
      if (this.track) this.track.addEventListener('scroll', this.onStageScroll, { passive: true });
      if (this.thumbTrack) this.thumbTrack.addEventListener('scroll', this.onThumbScroll, { passive: true });

      ['variant:change', 'variantChange', 'product:variant-change', 'variant:changed'].forEach(function (evt) {
        document.addEventListener(evt, this.onVariantEvent);
      }, this);
      document.addEventListener('change', this.onFormChange, true);

      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(this.measure);
        this.ro.observe(this);
      } else {
        window.addEventListener('resize', this.measure);
      }

      this.bindStageSwipe();
      this.measure();
      this.renderCounter();
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.onFormChange, true);
      ['variant:change', 'variantChange', 'product:variant-change', 'variant:changed'].forEach(function (evt) {
        document.removeEventListener(evt, this.onVariantEvent);
      }, this);
      if (this.ro) this.ro.disconnect();
      else window.removeEventListener('resize', this.measure);
      this.closeLightbox(true);
    }

    throttle(fn, wait) {
      var last = 0, timer = null, self = this;
      return function () {
        var args = arguments, now = Date.now();
        if (now - last >= wait) { last = now; fn.apply(self, args); return; }
        clearTimeout(timer);
        timer = setTimeout(function () { last = Date.now(); fn.apply(self, args); }, wait);
      };
    }

    readVariantMap() {
      var node = this.querySelector('[data-variant-media]');
      if (!node) return {};
      try { return JSON.parse(node.textContent) || {}; } catch (e) { return {}; }
    }

    /* --- layout --- */
    measure() {
      var stage = this.querySelector('.gx_stage');
      if (this.thumbRail && stage && isDesktop()) {
        this.thumbRail.style.setProperty('--gx-thumb-rail-h', stage.offsetHeight + 'px');
      } else if (this.thumbRail) {
        this.thumbRail.style.removeProperty('--gx-thumb-rail-h');
      }
      this.updateThumbNav();
    }

    updateThumbNav() {
      var track = this.thumbTrack;
      if (!track || !this.thumbRail) return;
      var vertical = isDesktop();
      var size = vertical ? track.clientHeight : track.clientWidth;
      var scrollSize = vertical ? track.scrollHeight : track.scrollWidth;
      var pos = vertical ? track.scrollTop : track.scrollLeft;
      var overflow = scrollSize - size > 2;

      this.thumbRail.classList.toggle('has-overflow', overflow);
      var up = this.querySelector('[data-thumb-nav="-1"]');
      var down = this.querySelector('[data-thumb-nav="1"]');
      if (up) up.disabled = !overflow || pos <= 1;
      if (down) down.disabled = !overflow || pos + size >= scrollSize - 1;
    }

    /* --- interaction --- */
    onClick(event) {
      var thumb = event.target.closest('.gx_thumb');
      if (thumb) { this.select(Number(thumb.dataset.thumb), true); return; }

      var dot = event.target.closest('.gx_dot');
      if (dot) { this.select(Number(dot.dataset.dot), true); return; }

      var nav = event.target.closest('[data-stage-nav]');
      if (nav) { this.step(Number(nav.dataset.stageNav)); return; }

      var tnav = event.target.closest('[data-thumb-nav]');
      if (tnav) { this.scrollThumbs(Number(tnav.dataset.thumbNav)); return; }

      if (event.target.closest('[data-stage-zoom]')) { this.openLightbox(this.index); return; }

      var img = event.target.closest('.gx_slide[data-media-type="image"] > img');
      if (img) this.openLightbox(Number(img.closest('.gx_slide').dataset.slide));
    }

    bindStageSwipe() {
      var stage = this.querySelector('.gx_stage');
      if (!stage) return;
      var startX = 0, startY = 0, active = false, self = this;

      stage.addEventListener('pointerdown', function (e) {
        if (!isDesktop()) return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (e.target.closest('button, model-viewer, video, iframe')) return;
        active = true; startX = e.clientX; startY = e.clientY;
      });
      stage.addEventListener('pointerup', function (e) {
        if (!active) return;
        active = false;
        var dx = e.clientX - startX;
        var dy = e.clientY - startY;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy)) self.step(dx < 0 ? 1 : -1);
      });
      stage.addEventListener('pointercancel', function () { active = false; });
    }

    onStageScroll() {
      if (isDesktop() || !this.track) return;
      var i = Math.round(this.track.scrollLeft / this.track.clientWidth);
      if (i !== this.index && this.slides[i]) this.setActiveState(i);
    }

    onFormChange(event) {
      var el = event.target;
      if (!el || el.name !== 'id' || !this.scope.contains(el)) return;
      this.syncVariant(el.value);
    }

    onVariantEvent(event) {
      var detail = event.detail || {};
      var variant = detail.variant || detail;
      if (!variant) return;
      if (variant.featured_media && variant.featured_media.id) this.selectByMediaId(variant.featured_media.id);
      else if (variant.id) this.syncVariant(variant.id);
    }

    syncVariant(variantId) {
      var mediaId = this.variantMap[String(variantId)];
      if (mediaId) this.selectByMediaId(mediaId);
    }

    selectByMediaId(mediaId) {
      var idx = this.slides.findIndex(function (s) { return s.dataset.mediaId === String(mediaId); });
      if (idx > -1) this.select(idx, false);
    }

    step(dir) {
      var next = (this.index + dir + this.slides.length) % this.slides.length;
      this.select(next, true);
    }

    select(index, userInitiated) {
      index = Math.min(Math.max(index, 0), this.slides.length - 1);
      this.setActiveState(index);

      if (!isDesktop() && this.track) {
        this.track.scrollTo({ left: index * this.track.clientWidth, behavior: userInitiated ? 'smooth' : 'auto' });
      }
      var thumb = this.thumbs[index];
      if (thumb) thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      this.pauseMedia(index);
    }

    setActiveState(index) {
      this.index = index;
      this.slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      this.thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === index);
        t.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      this.dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
      this.renderCounter();
      this.updateThumbNav();
    }

    renderCounter() {
      if (this.counter) this.counter.textContent = (this.index + 1) + ' / ' + this.slides.length;
    }

    pauseMedia(activeIndex) {
      this.slides.forEach(function (slide, i) {
        if (i === activeIndex) return;
        var video = slide.querySelector('video');
        if (video && !video.paused) video.pause();
        var mv = slide.querySelector('model-viewer');
        if (mv && typeof mv.pause === 'function') mv.pause();
      });
    }

    scrollThumbs(dir) {
      if (!this.thumbTrack) return;
      var vertical = isDesktop();
      var first = this.thumbs[0];
      var step = (first ? (vertical ? first.offsetHeight : first.offsetWidth) : 80) + 10;
      var delta = dir * step * 2;
      if (vertical) this.thumbTrack.scrollBy({ top: delta, behavior: 'smooth' });
      else this.thumbTrack.scrollBy({ left: delta, behavior: 'smooth' });
    }

    /* ============================================================
       Lightbox
       ============================================================ */
    lightboxItems() {
      return this.slides
        .filter(function (s) { return s.dataset.mediaType === 'image'; })
        .map(function (s) {
          var img = s.querySelector('img');
          return {
            src: (img && img.dataset.zoomSrc) || (img && img.src),
            thumb: (img && img.currentSrc) || (img && img.src),
            alt: (img && img.alt) || '',
            slide: Number(s.dataset.slide)
          };
        });
    }

    openLightbox(slideIndex) {
      var items = this.lightboxItems();
      if (!items.length) return;
      this.lbItems = items;
      var pos = items.findIndex(function (it) { return it.slide === slideIndex; });
      this.lbIndex = pos > -1 ? pos : 0;

      if (!this.lb) this.buildLightbox();
      this.renderThumbStrip();
      this.renderLightbox(0);

      this.lb.hidden = false;
      document.body.classList.add('gx-lb-open');
      requestAnimationFrame(function () { this.lb.classList.add('is-open'); }.bind(this));

      document.addEventListener('keydown', this.onKey);
      this.lastFocus = document.activeElement;
      this.lb.querySelector('[data-lb-close]').focus({ preventScroll: true });
      this.preloadNeighbours();
    }

    closeLightbox(immediate) {
      if (!this.lb || this.lb.hidden) return;
      this.lb.classList.remove('is-open');
      document.body.classList.remove('gx-lb-open');
      document.removeEventListener('keydown', this.onKey);

      var lb = this.lb;
      var hide = function () { lb.hidden = true; };
      if (immediate) hide();
      else window.setTimeout(hide, 340);

      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
    }

    onKey(event) {
      if (event.key === 'Escape') { this.closeLightbox(); return; }
      if (event.key === 'ArrowRight') { this.stepLightbox(1); return; }
      if (event.key === 'ArrowLeft') { this.stepLightbox(-1); return; }
      if (event.key === 'Tab') this.trapFocus(event);
    }

    trapFocus(event) {
      var nodes = this.lb.querySelectorAll('button:not([hidden])');
      if (!nodes.length) return;
      var first = nodes[0], last = nodes[nodes.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }

    stepLightbox(dir) {
      if (!this.lbItems || this.lbItems.length < 2) return;
      this.lbIndex = (this.lbIndex + dir + this.lbItems.length) % this.lbItems.length;
      this.renderLightbox(dir);
      this.select(this.lbItems[this.lbIndex].slide, false);
      this.preloadNeighbours();
    }

    goToLightbox(i) {
      if (i === this.lbIndex) return;
      var dir = i > this.lbIndex ? 1 : -1;
      this.lbIndex = i;
      this.renderLightbox(dir);
      this.select(this.lbItems[i].slide, false);
      this.preloadNeighbours();
    }

    preloadNeighbours() {
      var self = this;
      [-1, 1].forEach(function (d) {
        var i = (self.lbIndex + d + self.lbItems.length) % self.lbItems.length;
        var im = new Image();
        im.src = self.lbItems[i].src;
      });
    }

    buildLightbox() {
      var el = document.createElement('div');
      el.className = 'gx_lb';
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');
      el.setAttribute('aria-label', 'Product image gallery');
      el.hidden = true;
      el.innerHTML =
        '<button type="button" class="gx_lb__scrim" data-lb-close tabindex="-1" aria-hidden="true"></button>' +
        '<div class="gx_lb__shell">' +
          '<button type="button" class="gx_lb__close" data-lb-close aria-label="Close gallery">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg>' +
          '</button>' +
          '<button type="button" class="gx_lb__arrow gx_lb__arrow--prev" data-lb-step="-1" aria-label="Previous image">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="m15 6-6 6 6 6"/></svg>' +
          '</button>' +
          '<figure class="gx_lb__fig" data-lb-fig><img data-lb-img src="" alt=""></figure>' +
          '<button type="button" class="gx_lb__arrow gx_lb__arrow--next" data-lb-step="1" aria-label="Next image">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="m9 6 6 6-6 6"/></svg>' +
          '</button>' +
          '<div class="gx_lb__bar">' +
            '<div class="gx_lb__thumbs" data-lb-thumbs></div>' +
            '<span class="gx_lb__count" data-lb-count></span>' +
          '</div>' +
        '</div>';
      document.body.appendChild(el);

      var self = this;
      el.addEventListener('click', function (event) {
        if (event.target.closest('[data-lb-close]')) { self.closeLightbox(); return; }
        var step = event.target.closest('[data-lb-step]');
        if (step) { self.stepLightbox(Number(step.dataset.lbStep)); return; }
        var t = event.target.closest('[data-lb-thumb]');
        if (t) self.goToLightbox(Number(t.dataset.lbThumb));
      });

      var sx = 0, sy = 0, dragging = false;
      var fig = el.querySelector('[data-lb-fig]');
      fig.addEventListener('pointerdown', function (e) { dragging = true; sx = e.clientX; sy = e.clientY; });
      fig.addEventListener('pointerup', function (e) {
        if (!dragging) return;
        dragging = false;
        var dx = e.clientX - sx, dy = e.clientY - sy;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) self.stepLightbox(dx < 0 ? 1 : -1);
      });
      fig.addEventListener('pointercancel', function () { dragging = false; });

      this.lb = el;
    }

    renderThumbStrip() {
      var wrap = this.lb.querySelector('[data-lb-thumbs]');
      wrap.hidden = this.lbItems.length < 2;
      wrap.innerHTML = this.lbItems.map(function (it, i) {
        return '<button type="button" class="gx_lb__thumb" data-lb-thumb="' + i + '" aria-label="Image ' + (i + 1) + '">' +
          '<img src="' + it.thumb + '" alt=""></button>';
      }).join('');
    }

    renderLightbox(dir) {
      var item = this.lbItems[this.lbIndex];
      var fig = this.lb.querySelector('[data-lb-fig]');
      var img = this.lb.querySelector('[data-lb-img]');
      var self = this;

      var apply = function () {
        img.src = item.src;
        img.alt = item.alt;
        fig.classList.remove('is-out-next', 'is-out-prev', 'is-in-next', 'is-in-prev');
        if (dir) void fig.offsetWidth;
        if (dir > 0) fig.classList.add('is-in-next');
        if (dir < 0) fig.classList.add('is-in-prev');
      };

      if (dir) {
        fig.classList.add(dir > 0 ? 'is-out-next' : 'is-out-prev');
        window.setTimeout(apply, 190);
      } else {
        apply();
      }

      this.lb.querySelector('[data-lb-count]').textContent = (this.lbIndex + 1) + ' / ' + this.lbItems.length;
      var single = this.lbItems.length < 2;
      this.lb.querySelectorAll('[data-lb-step]').forEach(function (b) { b.hidden = single; });
      this.lb.querySelectorAll('[data-lb-thumb]').forEach(function (b, i) {
        b.classList.toggle('is-active', i === self.lbIndex);
        if (i === self.lbIndex) b.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      });
    }
  }

  if (!customElements.get('glixor-gallery')) customElements.define('glixor-gallery', GlixorGallery);

  /* ================================================================
     Purchase options
     ================================================================ */
  class GlixorPurchaseOptions extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('main-product') || document;
      this.addEventListener('change', this.sync.bind(this));
      this.sync();
    }

    forms() {
      return Array.prototype.slice
        .call(this.scope.querySelectorAll('form[action*="/cart/add"]'))
        .filter(function (form) { return (form.id || '').indexOf('installment') === -1; });
    }

    sync() {
      var checked = this.querySelector('input[type="radio"]:checked');
      var value = checked ? checked.value : '';

      this.querySelectorAll('.gx_option').forEach(function (opt) {
        var input = opt.querySelector('input[type="radio"]');
        opt.classList.toggle('is-selected', !!input && input.checked);
      });

      this.forms().forEach(function (form) {
        var input = form.querySelector('input[name="selling_plan"]');
        if (!value) { if (input) input.remove(); return; }
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'selling_plan';
          form.appendChild(input);
        }
        input.value = value;
      });

      var display = checked && checked.dataset.priceDisplay;
      var target = this.scope.querySelector('[data-gx-price-now]');
      if (display && target) target.textContent = display;

      this.dispatchEvent(new CustomEvent('glixor:selling-plan', { bubbles: true, detail: { sellingPlanId: value } }));
    }
  }

  if (!customElements.get('glixor-purchase-options')) {
    customElements.define('glixor-purchase-options', GlixorPurchaseOptions);
  }


  /* ================================================================
     Benefits slider
     ================================================================ */
  class GlixorBenefits extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-btrack]');
      if (!this.track) return;

      this.items = Array.prototype.slice.call(this.querySelectorAll('.gx_benefit'));
      this.onClick = this.onClick.bind(this);
      this.update = this.update.bind(this);

      this.addEventListener('click', this.onClick);
      this.track.addEventListener('scroll', this.update, { passive: true });

      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(this.update);
        this.ro.observe(this);
      } else {
        window.addEventListener('resize', this.update);
      }

      this.update();
      this.startAuto();

      this.addEventListener('pointerenter', this.stopAuto.bind(this));
      this.addEventListener('pointerleave', this.startAuto.bind(this));
      this.addEventListener('focusin', this.stopAuto.bind(this));
    }

    disconnectedCallback() {
      this.stopAuto();
      if (this.ro) this.ro.disconnect();
      else window.removeEventListener('resize', this.update);
    }

    get overflowing() {
      return this.track.scrollWidth - this.track.clientWidth > 4;
    }

    update() {
      var over = this.overflowing;
      this.classList.toggle('has-overflow', over);

      var prev = this.querySelector('[data-bnav="-1"]');
      var next = this.querySelector('[data-bnav="1"]');
      var pos = this.track.scrollLeft;
      if (prev) prev.disabled = !over || pos <= 2;
      if (next) next.disabled = !over || pos + this.track.clientWidth >= this.track.scrollWidth - 2;
    }

    onClick(event) {
      var nav = event.target.closest('[data-bnav]');
      if (!nav) return;
      this.stopAuto();
      this.step(Number(nav.dataset.bnav));
    }

    step(dir) {
      var first = this.items[0];
      var w = first ? first.offsetWidth : this.track.clientWidth / 2;
      this.track.scrollBy({ left: dir * w, behavior: 'smooth' });
    }

    startAuto() {
      if (this.dataset.autoplay !== 'true' || !this.overflowing) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.stopAuto();
      var self = this;
      var ms = (Number(this.dataset.speed) || 4) * 1000;
      this.timer = window.setInterval(function () {
        var atEnd = self.track.scrollLeft + self.track.clientWidth >= self.track.scrollWidth - 4;
        if (atEnd) self.track.scrollTo({ left: 0, behavior: 'smooth' });
        else self.step(1);
      }, ms);
    }

    stopAuto() {
      if (this.timer) { window.clearInterval(this.timer); this.timer = null; }
    }
  }

  if (!customElements.get('glixor-benefits')) customElements.define('glixor-benefits', GlixorBenefits);


  /* ================================================================
     Sticky ATC + size chart
     ================================================================ */
  function initSticky() {
    var bar = document.querySelector('sticky-atc');
    if (!bar || bar.dataset.gxBound) return;
    var anchor = document.querySelector('.gx_block--add-to-cart');
    if (!anchor) return;
    bar.dataset.gxBound = 'true';

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
    }, { rootMargin: '0px 0px -100% 0px' });
    observer.observe(anchor);

    var btn = bar.querySelector('[data-sticky-btn]');
    if (btn) {
      btn.addEventListener('click', function () {
        var submit = anchor.querySelector('button[type="submit"]');
        if (submit) submit.click();
        else anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

  function initSizeChart() {
    var popup = document.querySelector('.size_chart_popup_wrapper');
    if (!popup || popup.dataset.gxBound) return;
    popup.dataset.gxBound = 'true';

    document.addEventListener('click', function (event) {
      if (event.target.closest('.size_chart_wrapper')) { popup.classList.add('is-open'); return; }
      if (event.target.closest('.size_chart_popup_close') || event.target === popup) popup.classList.remove('is-open');
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') popup.classList.remove('is-open');
    });
  }


      function initQtyPress() {
    if (document.body.dataset.gxQtyBound) return;
    document.body.dataset.gxQtyBound = 'true';

    document.addEventListener('pointerdown', function (event) {
      var btn = event.target.closest('.gx_qty__shell button');
      if (!btn || btn.disabled) return;
      btn.classList.add('is-pressed');
      window.setTimeout(function () { btn.classList.remove('is-pressed'); }, 180);
    });
  }


    function boot() { initSticky(); initSizeChart(); initQtyPress(); }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();